import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./Components/about";
import Home from "./Components/home";
import Product from "./Components/Product";
import Motion from "./Components/Motion";
import Branding from "./Components/Branding";
import "./fonts/Kastelov-Axiforma-Black.otf";
import "./fonts/Kastelov-Axiforma-Regular.otf";
import "./fonts/Kastelov-Axiforma-Medium.otf";
import "./fonts/Kastelov-Axiforma-Light.otf";
import "./fonts/Kastelov-Axiforma-Book.otf";
import "./fonts/Kastelov-Axiforma-SemiBold.otf";
import "./fonts/Kastelov-Axiforma-Bold.otf";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<React.StrictMode>
		<BrowserRouter>
			<Routes>
				<Route element={<App />}>
					<Route index path="/" element={<Home />} />
					<Route path="/branding" element={<Branding />} />
					<Route path="/product" element={<Product />} />
					<Route path="/motion" element={<Motion />} />
					<Route path="/about" element={<About />} />
					<Route path="/*" element={<Home />} />
				</Route>
			</Routes>
		</BrowserRouter>
	</React.StrictMode>
);
